module.exports = __webpack_public_path__ + "wp8_inverseicons.cd3081f7a6be2eea7365.png";


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/external_css/kendo-ui/images/wp8_inverseicons.png
// module id = ../../../../../external_css/kendo-ui/images/wp8_inverseicons.png
// module chunks = styles